/* ============================================================
   PREMIUM DTC THEME — Vanilla JS
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Reveal on scroll ---------- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  var revealCheck = function () {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    revealEls = revealEls.filter(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vh - 40 && rect.bottom > 0) {
        el.classList.add('is-visible');
        return false;
      }
      return true;
    });
    if (!revealEls.length && revealTimer) { clearInterval(revealTimer); }
  };
  var revealTimer = setInterval(revealCheck, 250);
  window.addEventListener('scroll', revealCheck, { passive: true });
  revealCheck();

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('.header');
  if (header) {
    var onScrollHeader = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScrollHeader, { passive: true });
    onScrollHeader();
  }

  /* ---------- Gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src = thumb.getAttribute('data-src');
        var tpl = thumb.querySelector('template');
        if (tpl) {
          main.innerHTML = '';
          main.appendChild(tpl.content.cloneNode(true));
          var badge = gallery.getAttribute('data-badge');
          if (badge) {
            var b = document.createElement('span');
            b.className = 'gallery__badge';
            b.textContent = badge;
            main.prepend(b);
          }
        } else if (src) {
          var img = main.querySelector('img');
          if (img) { img.src = src; }
        }
      });
    });
  });

  /* ---------- Quantity selector ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    qty.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- Variant swatches ---------- */
  document.querySelectorAll('[data-swatch-group]').forEach(function (group) {
    var label = group.querySelector('[data-swatch-value]');
    group.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        if (label) { label.textContent = sw.getAttribute('data-value') || sw.textContent.trim(); }
      });
    });
  });

  /* ---------- Accordions ---------- */
  document.querySelectorAll('.acc-item').forEach(function (item) {
    var trigger = item.querySelector('.acc-trigger');
    var panel = item.querySelector('.acc-panel');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      var parent = item.closest('[data-accordion-single]');
      if (parent && !isOpen) {
        parent.querySelectorAll('.acc-item.is-open').forEach(function (open) {
          open.classList.remove('is-open');
          open.querySelector('.acc-panel').style.maxHeight = '0px';
          open.querySelector('.acc-trigger').setAttribute('aria-expanded', 'false');
        });
      }
      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
    });
  });

  /* ---------- Button ripple ---------- */
  document.querySelectorAll('.btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var rect = btn.getBoundingClientRect();
      var d = Math.max(rect.width, rect.height);
      var span = document.createElement('span');
      span.className = 'ripple';
      span.style.width = span.style.height = d + 'px';
      span.style.left = (e.clientX - rect.left - d / 2) + 'px';
      span.style.top = (e.clientY - rect.top - d / 2) + 'px';
      btn.appendChild(span);
      setTimeout(function () { span.remove(); }, 600);
    });
  });

  /* ---------- Sticky Add-To-Cart ---------- */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var buyBox = document.querySelector('[data-buy-box]');
  if (stickyAtc && buyBox) {
    var atcTick = false;
    var updateStickyAtc = function () {
      atcTick = false;
      stickyAtc.classList.toggle('is-visible', buyBox.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', function () {
      if (!atcTick) { atcTick = true; requestAnimationFrame(updateStickyAtc); }
    }, { passive: true });
    setInterval(updateStickyAtc, 400);
    updateStickyAtc();
  }

  /* ---------- Smooth scroll for anchors ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
})();
